import React from 'react';
import { IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import styles from '../modalPayment.module.scss';
import { PaymentContentProps } from '../../../../../../interfaces/pages';

export const PaymentContent: React.FC<PaymentContentProps> = ({
    handleCloseClick,
    isPaymentCancelled,
    getPaymentStatusContent
}) => (
    <div className={styles.paymentContent}>
        {isPaymentCancelled ? (
            <>
                <div className={styles.closeButton}>
                    <IconButton onClick={handleCloseClick}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <CancelOutlinedIcon className={styles.cancelIcon} />
                <p className={`${styles.statusText} ${styles.cancelled}`}>Pago cancelado</p>
            </>
        ) : (
            <>
                <div className={styles.paymentStatus}>
                    {getPaymentStatusContent()}
                </div>
            </>
        )}
    </div>
);
